import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { TID } from "@/constants/testIds";
import { Check, X, Star, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { Link } from "react-router-dom";

export default function AgencyJobs() {
  const [items, setItems] = useState([]);
  const load = async () => {
    const { data } = await api.get("/jobs/mine");
    setItems(data.items || []);
  };
  useEffect(() => { load(); }, []);

  const approve = async (id, ok) => {
    await api.put(`/jobs/${id}`, { is_approved: ok });
    toast.success(ok ? "Approved" : "Rejected");
    load();
  };
  const feature = async (id, on) => {
    await api.put(`/jobs/${id}`, { is_featured: on });
    toast.success(on ? "Featured" : "Unfeatured");
    load();
  };
  const close = async (id) => {
    await api.put(`/jobs/${id}`, { is_active: false });
    toast.success("Closed");
    load();
  };

  return (
    <div>
      <div className="mb-6">
        <div className="eyebrow mb-2">Agency Owner</div>
        <h1 className="font-display text-3xl font-bold text-navy">All Job Postings</h1>
      </div>

      <div data-testid={TID.agencyJobsTable} className="border border-slate-200 rounded-xl bg-white overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b">
            <tr className="text-left text-slate-500">
              <th className="p-3">Title</th><th className="p-3">Employer</th><th className="p-3">Type</th>
              <th className="p-3">Location</th><th className="p-3">Status</th><th className="p-3">Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.map(j => (
              <tr key={j.id} className="border-b last:border-0 hover:bg-slate-50">
                <td className="p-3 font-medium text-navy">
                  <Link to={`/jobs/${j.id}`} className="inline-flex items-center gap-1">
                    {j.title} <ExternalLink className="w-3 h-3 text-slate-400" />
                  </Link>
                  {j.is_featured && <Star className="w-3.5 h-3.5 text-gold inline ml-2 fill-current" />}
                </td>
                <td className="p-3 text-slate-600">{j.employer_name}</td>
                <td className="p-3 text-slate-600">{j.employment_type} • {j.work_arrangement}</td>
                <td className="p-3 text-slate-600">{j.city}{j.state ? `, ${j.state}` : ""}</td>
                <td className="p-3 text-xs">
                  {!j.is_active ? <span className="text-slate-500">Closed</span>
                    : j.is_approved ? <span className="text-emerald-600">Live</span>
                    : <span className="text-amber-600">Pending review</span>}
                </td>
                <td className="p-3 text-xs space-x-2">
                  {j.is_active && !j.is_approved && <button onClick={() => approve(j.id, true)} className="text-emerald-600">Approve</button>}
                  {j.is_active && j.is_approved && <button onClick={() => feature(j.id, !j.is_featured)} className="text-gold">{j.is_featured ? "Unfeature" : "Feature"}</button>}
                  {j.is_active && <button onClick={() => close(j.id)} className="text-red-500">Close</button>}
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td className="p-6 text-center text-slate-500" colSpan={6}>No jobs yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
